/* Bellacombe: aanbevelingsrij onder de productpagina per bezoeker (2026-10-20, naar Vesnia mb-rel-personal.js).
   UK  = "You may also like" (sections/product-recommendations.liquid, 4 kaarten)
   AU/US = "EXTRA DISCOUNTS WHEN YOU BUY 2 OR MORE!" (sections/bd-recommendations.liquid, 5 kaarten)
   Beide secties halen nu 10 Shopify-aanbevelingen op (data-mb-keep = hoeveel er blijven staan). Dit script kiest
   per bezoeker welke blijven, op basis van wat die eerder bekeek en in de winkelwagen legde:
   - soort product (bv. eerder midi-jurken bekeken -> midi-jurken eerst), stijl-tags (elegant, casual, ...),
     kleurfamilie en prijsniveau binnen de groep;
   - eerder bekeken product = herinnering (bonus); al in de winkelwagen = overslaan.
   De volgorde van Shopify telt mee, dus een nieuwe bezoeker krijgt vrijwel de gewone rij.
   Zonder JS: CSS toont de eerste 4/5 (zelfde als vroeger).
   Profiel alleen op dit apparaat (localStorage mb_prof_v1) en alleen met toestemming voor "voorkeuren" in de
   cookiebanner; geweigerd = profiel gewist. */
(function () {
  'use strict';
  if (window.__mbRecosInit) return;
  window.__mbRecosInit = true;
  var KEY = 'mb_prof_v1';
  var MAXV = 40;
  var MAXAGE = 60 * 864e5;
  var curEl = document.getElementById('mb-cur');
  if (!curEl) return;
  var cur;
  try { cur = JSON.parse(curEl.textContent); } catch (e) { return; }

  // ---------- kenmerken ----------
  var FAM = [
    ['print', /floral|flower|leopard|zebra|snake|animal|print|pattern|check|plaid|stripe|polka|dots|camo|multi|tie.?dye|paisley/],
    ['white', /white|ivory|cream|ecru|pearl/],
    ['beige', /beige|nude|sand|camel|taupe|champagne|oatmeal|apricot/],
    ['brown', /brown|coffee|chocolate|caramel|\btan\b|mocha|cognac|chestnut|rust/],
    ['black', /black/],
    ['grey', /grey|gray|silver|charcoal|graphite/],
    ['blue', /blue|navy|denim|teal|turquoise|cobalt|azure|aqua/],
    ['green', /green|olive|khaki|mint|sage|emerald|army/],
    ['red', /\bred\b|burgundy|wine|maroon|claret|cherry/],
    ['pink', /pink|rose|fuchsia|blush|coral|magenta|salmon/],
    ['purple', /purple|violet|lilac|lavender|plum|mauve/],
    ['yellow', /yellow|mustard|gold|lemon/],
    ['orange', /orange|peach/]
  ];
  function fam(name) {
    var n = String(name || '').toLowerCase();
    for (var i = 0; i < FAM.length; i++) if (FAM[i][1].test(n)) return FAM[i][0];
    return '';
  }
  function fams(list) {
    var o = {};
    (list || []).forEach(function (c) { var f = fam(c); if (f) o[f] = 1; });
    return Object.keys(o);
  }
  var STOP = /^(women|woman|ladies|lady|mens|men's|fashion|cloth|style|wear$|outfit|bellac)/;
  function toks(tags) {
    var o = {};
    String(tags || '').toLowerCase().split('|').forEach(function (t) {
      t.split(/[\s\/,.-]+/).forEach(function (w) { if (w.length >= 4 && !STOP.test(w)) o[w.slice(0, 6)] = 1; });
    });
    return Object.keys(o);
  }
  function typeKey(y) {
    return String(y || '').toLowerCase().replace(/\b(wo)?men'?s\b/g, '').replace(/\s+/g, ' ').trim()
      .replace(/(dress|blouse)es$/, '$1').replace(/s$/, '');
  }
  function groupOf(y) {
    var t = String(y || '').toLowerCase();
    var men = /\bmen'?s\b|\bmens\b/.test(t) && !/women/.test(t);
    var g =
      /dress/.test(t) ? 'dresses' :
      /swim|bikini|tankini/.test(t) ? 'swim' :
      /\bset\b|jumpsuit|playsuit|romper|dungaree|co-ord|suit|tracksuit/.test(t) ? 'sets' :
      /coat|jacket|blazer|waistcoat|gilet|kimono|kurtka/.test(t) ? 'outer' :
      /shoe|boot|heel|sandal|trainer|sneaker|loafer|pump|flat|mule|wedge/.test(t) ? 'shoes' :
      /bag|tote|clutch/.test(t) ? 'bags' :
      /trouser|jean|skirt|short|legging|pant/.test(t) ? 'bottoms' :
      /top|blouse|shirt|jumper|sweater|cardigan|kardigan|knit|hoodie|sweatshirt|tee\b|bustier|bralette|vest/.test(t) ? 'tops' :
      /jewel|necklace|earring|bracelet|ring|watch|sunglass|glasses|belt|scarf|hat\b|glove|sock|sieraad|accessor/.test(t) ? 'acc' : '';
    return men && g ? 'm_' + g : g;
  }
  function prep(c) {
    if (c._ok) return c;
    c._y = typeKey(c.y);
    c._g = groupOf(c.y);
    c._k = fams(String(c.k || '').split('|'));
    c._s = toks(c.s);
    c._ok = true;
    return c;
  }

  // ---------- toestemming (Shopify-cookiebanner, categorie "voorkeuren") ----------
  var consent = false;
  function readConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.preferencesProcessingAllowed === 'function') return cp.preferencesProcessingAllowed() !== false;
      return !(window.Shopify && typeof window.Shopify.loadFeatures === 'function');
    } catch (e) {}
    return false;
  }
  function withConsent(cb) {
    var done = false;
    function fin(v) { if (done) return; done = true; consent = v; cb(); }
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) return fin(readConsent());
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { fin(err ? false : readConsent()); });
        setTimeout(function () { fin(false); }, 4000);
        return;
      }
    } catch (e) {}
    fin(readConsent());
  }
  function forget() { try { localStorage.removeItem(KEY); } catch (e) {} }
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = (e && e.detail) || {};
    if (d.preferencesAllowed === true) { consent = true; saveProf(); }
    else if (d.preferencesAllowed === false) { consent = false; forget(); }
  });

  // ---------- profiel ----------
  var prof = { v: [], cart: [] };
  function loadProf() {
    try {
      var j = JSON.parse(localStorage.getItem(KEY));
      if (j && Array.isArray(j.v)) {
        var now = Date.now();
        j.v = j.v.filter(function (e) { return e && e.id && now - (e.ts || 0) < MAXAGE; });
        j.cart = Array.isArray(j.cart) ? j.cart : [];
        return j;
      }
    } catch (e) {}
    return { v: [], cart: [] };
  }
  function saveProf() {
    if (!consent) return;
    try { localStorage.setItem(KEY, JSON.stringify({ v: prof.v, cart: prof.cart })); } catch (e) {}
  }
  prep(cur);
  var curEntry = { id: cur.id, g: cur._g, y: cur._y, p: cur.p, k: cur.sc ? fams([cur.sc]) : cur._k, s: cur._s, ts: Date.now() };

  // ---------- score ----------
  function sat(x) { return x > 0 ? x / (x + 1) : 0; }
  function median(a) { var s = a.slice().sort(function (x, y) { return x - y; }); var m = s.length >> 1; return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2; }
  function weights() {
    var W = { y: {}, s: {}, k: {}, g: {}, pr: {}, seen: {} };
    function add(e, w) {
      if (e.y) W.y[e.y] = (W.y[e.y] || 0) + w;
      if (e.g) W.g[e.g] = (W.g[e.g] || 0) + w;
      (e.k || []).forEach(function (k) { W.k[k] = (W.k[k] || 0) + w; });
      (e.s || []).forEach(function (t) { W.s[t] = (W.s[t] || 0) + w; });
      if (e.g && e.p) (W.pr[e.g] = W.pr[e.g] || []).push(e.p);
    }
    prof.v.forEach(function (e, i) { add(e, Math.pow(0.85, i)); if (e.id !== cur.id) W.seen[e.id] = 1; });
    prof.cart.forEach(function (e) { add(e, 3); });
    return W;
  }
  function scoreOf(c, pos, n, W) {
    var s = (2 * (n - pos)) / n; // plek in de Shopify-aanbevelingen
    if (c._y && W.y[c._y]) s += 2 * sat(W.y[c._y]); // zelfde soort product eerder bekeken
    if (c._g && W.g[c._g]) s += 0.75 * sat(W.g[c._g]); // groep die de bezoeker vaak bekijkt
    var st = 0;
    c._s.forEach(function (t) { st += W.s[t] || 0; });
    s += 1.5 * sat(st / 2); // stijl
    var kk = 0;
    c._k.forEach(function (k) { kk = Math.max(kk, W.k[k] || 0); });
    s += sat(kk); // kleurfamilie
    var pr = W.pr[c._g];
    if (pr && pr.length && c.p) { var m = median(pr); s += 1 - Math.min(1, Math.abs(c.p - m) / m); } // prijsniveau
    if (W.seen[c.id]) s += 1; // eerder bekeken: herinnering
    return s;
  }

  // ---------- rij ordenen ----------
  var ready = false;
  function units(cont) { return Array.prototype.filter.call(cont.children, function (u) { return u.classList.contains('mb-rc-unit'); }); }
  function sig(list) { return list.map(function (u) { return u.getAttribute('data-mb-pid'); }).join(','); }
  function process(cont) {
    var list = units(cont);
    if (!list.length || cont.dataset.mbSig === sig(list)) return;
    var keep = +cont.dataset.mbKeep || 4;
    var W = weights();
    var inCart = {};
    prof.cart.forEach(function (e) { inCart[e.id] = 1; });
    var n = list.length;
    var rows = list.map(function (u, i) {
      var c = null;
      try { c = prep(JSON.parse(u.querySelector('script.mb-rc').textContent)); } catch (e) {}
      var skip = !c || c.id === cur.id || inCart[c.id];
      return { u: u, c: c, i: i, skip: !!skip, s: c ? scoreOf(c, i, n, W) : -99 };
    });
    rows.sort(function (a, b) { return (a.skip - b.skip) || (b.s - a.s) || (a.i - b.i); });
    rows.forEach(function (r, i) {
      cont.appendChild(r.u);
      r.u.classList.toggle('mb-rc-off', r.skip || i >= keep);
    });
    cont.dataset.mbSig = sig(units(cont));
    cont.setAttribute('data-mb-personal', '1');
    window.mbRecos = { prof: prof, keep: keep, rows: rows.map(function (r) { return { id: r.c && r.c.id, y: r.c && r.c.y, s: Math.round(r.s * 100) / 100, shown: !r.u.classList.contains('mb-rc-off') }; }) };
  }
  function scan() {
    if (!ready) return;
    document.querySelectorAll('[data-mb-keep]').forEach(process);
  }
  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(scan, 30); }

  // ---------- winkelwagen ----------
  function fromCart(c) {
    return ((c && c.items) || []).map(function (it) {
      var col = '';
      (it.options_with_values || []).forEach(function (o) { if (/colou?r|kolor|colore/i.test(o.name)) col = o.value; });
      return { id: it.product_id, g: groupOf(it.product_type), y: typeKey(it.product_type), p: it.final_price || it.price, k: col ? fams([col]) : [], s: [] };
    });
  }
  function loadCart(cb) {
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { prof.cart = fromCart(c); saveProf(); })
      .catch(function () {})
      .then(cb);
  }

  withConsent(function () {
    if (consent) prof = loadProf();
    else forget();
    prof.v = [curEntry].concat(prof.v.filter(function (e) { return e.id !== cur.id; })).slice(0, MAXV);
    saveProf();
    // winkelwagen pas ophalen als de rij in beeld komt (de aanbevelingen laden ook pas dan)
    var started = false;
    function start() { if (started) return; started = true; loadCart(function () { ready = true; scan(); }); }
    if (document.querySelector('[data-mb-keep] .mb-rc-unit')) start();
    new MutationObserver(function () { if (document.querySelector('[data-mb-keep] .mb-rc-unit')) { start(); soon(); } })
      .observe(document.body, { childList: true, subtree: true });
  });
})();
